import { isDropshippingFlow, ProductUtils } from '@wix/package-picker-shared';
import {
  useAiRecommendationEnabled,
  usePersonalizedParams,
} from '@wix/package-picker-shared-eclipse';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ProductCard } from './ProductCard/ProductCard';
import { ProductCardsSkeleton } from './ProductCardsSkeleton';

export const ProductCards = () => {
  const isDropshippingIntent = isDropshippingFlow();
  const { isEnabled: isAiRecommendationEnabled } = useAiRecommendationEnabled();
  const { isLoading: isPersonalizedContentLoading } =
    usePersonalizedParams();

  // Same skeleton the list's own loader renders — only a longer hold.
  if (isPersonalizedContentLoading) {
    return (
      <ProductCardsSkeleton
        numCards={isDropshippingIntent ? 3 : 4}
        isAiRecommendationEnabled={isAiRecommendationEnabled}
      />
    );
  }

  return (
    <ProductCardList.Default.Root
      gap={12}
      useLoader={() => (
        <ProductCardsSkeleton
          numCards={isDropshippingIntent ? 3 : 4}
          isAiRecommendationEnabled={isAiRecommendationEnabled}
        />
      )}
      width="100%"
    >
      {({ products }) => {
        const sortedProducts = ProductUtils.sortProducts({ products });

        return sortedProducts.map((product, cardIndex) => {
          if (!product.productId) {
            return null;
          }

          return (
            <ProductCard
              key={product.productId}
              productId={product.productId}
              cardIndex={cardIndex}
            />
          );
        });
      }}
    </ProductCardList.Default.Root>
  );
};
